export function transformForSelect(data, labelField, valueField) {
  return data.map((item) => ({
    data: item,
    label: item[labelField],
    value: item[valueField],
  }));
}